// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperClaimedToast-cls1_cpa","cls2":"PaperClaimedToast-cls2_DOO PaperClaimedToast-cls1_cpa"};